<template>
    <div>
      <maritimeService
        :name="heading"
        subProps="Marine industry software designed to streamline operations and improve efficiency"
      />
      <v-container>
        <v-row>
          <v-col sm="12" md="7" lg="7" class="mt-sm-20">
            <br />

            <h2>Cloud-Native ERP System for the Maritime Industry</h2>

            <v-img
                  src="@/assets/erp.jpg"
                  class="image"/>
                  
            <v-row class="pt-4">
              <div>
                <p class="ai-class">
                <br />
                Our company is developing a cutting-edge Enterprise Resource Planning (ERP) system specifically designed for the maritime industry. This comprehensive ERP solution will cater to the diverse needs of technical, commercial, and other departments within maritime organizations. Leveraging cloud-native technologies and utilizing Azure AKS for deployment, our ERP system will revolutionize maritime operations by streamlining processes, enhancing efficiency, and enabling data-driven decision-making.
                <br /><br />
              
              <strong>Key Features and Benefits:</strong>
                <ul>
                  <li>
                    <strong>Technical Tools:</strong> Our ERP system will provide a suite of technical tools tailored to the maritime industry. This includes asset management, maintenance scheduling, work order management, and documentation management. By centralizing technical operations, maritime companies can optimize maintenance processes, improve asset utilization, and minimize downtime.
                  </li>
                  <li>
                    <strong>Commercial Tools:</strong> Our ERP system will feature a range of commercial tools to facilitate smooth operations and maximize revenue generation. These tools will encompass contract management, voyage planning, chartering, freight management, and invoicing. By integrating commercial activities, maritime businesses can streamline their workflows, reduce administrative overhead, and ensure accurate financial reporting.
                  </li>
                  <li>
                    <strong>Cloud-Native Architecture:</strong> We have designed our ERP system to be cloud-native, leveraging the power and scalability of cloud technologies. By adopting cloud-native architecture, maritime companies can enjoy benefits such as high availability, automatic scaling, and seamless updates. This approach ensures that the ERP system can handle increasing workloads, adapt to changing business needs, and provide a reliable and secure platform for data management.
                  </li>
                  <li>
                    <strong>Azure AKS Deployment:</strong> To ensure efficient deployment and management of our ERP system, we have chosen Azure AKS (Azure Kubernetes Service). AKS provides a robust container orchestration platform that simplifies deployment, scaling, and monitoring of applications. By leveraging AKS, maritime organizations can take advantage of Azure's reliable infrastructure, automated scaling capabilities, and built-in security features.
                  </li>
                  <li>
                    <strong>Seamless Integration:</strong> Our ERP system will offer seamless integration with existing maritime software applications and external data sources. This enables data synchronization across different departments and systems, eliminating data silos and providing a unified view of operations. With seamless integration, maritime organizations can harness the power of their existing tools while leveraging the advanced capabilities of our ERP system.
                  </li>
                  <br/>
                  Our cloud-native ERP system for the maritime industry, powered by Azure AKS, aims to transform the way maritime organizations manage their technical, commercial, and other operations. By centralizing critical processes, optimizing workflows, and enabling data-driven decision-making, our ERP system empowers maritime companies to enhance efficiency, reduce costs, and drive sustainable growth in a rapidly evolving industry.
                </ul>
            </p>
              </div>
            </v-row>
          </v-col>

          <v-col sm="12" md="5" lg="5">
            <base-request />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService,
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Cloud-Native ERP System for the Maritime Industry";
  },
};
</script>
  <style scoped>
.ai-class {
  text-align: justify;
}
h2 {
  font-size: 30px;
  color: rgb(3, 50, 97);
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}
@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
  